<template>
    <UserActivityTile v-ripple="false" :userActivity="userActivity">
        <template v-slot:title>Joined us!</template>
        <template v-slot:subtitle>{{ userActivity.username }}</template>
        <template v-slot:append-item-right>
            <UserPlus :width="20" :height="25"></UserPlus>
        </template>
    </UserActivityTile>
</template>

<script lang="ts" setup>
import UserPlus from '@/icons/UserPlus.vue';
import { PropType } from 'vue';
import { ISignupUserActivity } from '@/interfaces/UserActivity/ISignupUserActivity';
import UserActivityTile from '@/components/Tiles/UserActivity/UserActivityTile.vue';

const props = defineProps({
    userActivity: {
        type: Object as PropType<ISignupUserActivity>,
        required: true,
    },
});
</script>
